import { create } from "zustand";
import { retrieveSubs, updateAccessStatus } from "./actions";

export const STATUS_BETA = 2;
export const STATUS_RELEASED = 3
export const ACCESS_BETA = "beta"
export const ACCESS_SUBSCRIBED = "subs"
export const ACCESS_DISALLOW = "dis"

export type SubsData = {
    com:string
    name: string
    id: string
    desc: string
    link: string
    status: number
    accessStatus: string
    iconl: string
}

type SubdProps = {
    apps: SubsData[] | null
    retrieveSubs: () => Promise<string>
    updateAccess: (status:string,app:string) => Promise<string>
}

export const useSubs = create<SubdProps>( (set,get) => ({
    apps: [],
    async updateAccess(status, app) {
        const code = await updateAccessStatus(app, status)
        if (code === "200") {
            const apps = [...get().apps!]
            const appIndex = apps?.findIndex( item => item.id === app)
            apps[appIndex].accessStatus = status
            set(state => ({apps:apps}))
        }
        return code
    },
    async retrieveSubs() {
        const res = await retrieveSubs()
        if (res.Code === "200") {
            const apps: SubsData[] = []
            const _apps = res.Msg.apps
            const _access = res.Msg.access
            
            for (const app of _apps) {
                let accessStatus = ACCESS_DISALLOW
                if (_access) {
                    for (const acc of _access) {
                        if (acc.App === app.id) {
                            accessStatus = acc.Status
                            break
                        }
                    }
                }
                apps.push({...app, accessStatus: accessStatus})
            }
            set(state => ({apps:apps}))
        }
        return res.Code
    },
}) );